import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/styles';
// import { Typography } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import { Page, PageHeader } from 'components';
import { useProperties } from 'hooks';

import PropertyForm from './components/PropertyForm';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  header: {
    marginBottom: theme.spacing(2),
  },
}));

const PropertyPage = ({ match }) => {
  const classes = useStyles();
  const pageProps = { actionFab: false };
  const { t } = useTranslation();
  const location = useLocation();
  const title = location.pathname === '/properties/create' ? 'property_new' : 'property_edit';
  const { PropertyId } = match && match.params;
  const [queriedId, setQueriedId] = useState();
  const { selectedProperty, setSelectedProperty, saveProperty, deleteProperty, isFetchingProperties, properties } =
    useProperties();

  let propToModify = Object.assign({}, selectedProperty);
  if (title === 'property_new') {
    propToModify = undefined;
  }

  useEffect(() => {
    if (PropertyId && !isFetchingProperties) {
      if (selectedProperty === undefined || selectedProperty.id !== PropertyId) {
        if (queriedId === undefined) {
          setQueriedId(PropertyId);
          setSelectedProperty(PropertyId);
        }
      }
    }
  }, [PropertyId, selectedProperty, setSelectedProperty, queriedId, isFetchingProperties]);

  return (
    <Page title={t(title)} className={classes.root}>
      <PageHeader title={title} {...pageProps} className={classes.header} />
      <PropertyForm property={propToModify} onSave={saveProperty} onDelete={deleteProperty} properties={properties} />
    </Page>
  );
};

PropertyPage.propTypes = {
  match: PropTypes.object.isRequired,

  //  newProperty: PropTypes.bool,
};

PropertyPage.defaultProps = {
  //  newProperty: true,
};

export default PropertyPage;
